import React, { useState, useEffect } from 'react';
import { noticeAPI } from '../../services/api';
import { Link } from 'react-router-dom';
import PageTitle from '../shared/PageTitle';

const AdminAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Handler to delete an announcement
  const handleDelete = async (annId) => {
    if (window.confirm('Are you sure you want to delete this announcement?')) {
      try {
        await noticeAPI.deleteAnnouncement(annId);
        setAnnouncements(prev => prev.filter(a => a.id !== annId));
      } catch (err) {
        console.error('Error deleting announcement:', err);
        setError('Failed to delete announcement.');
      }
    }
  };

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await noticeAPI.getAnnouncements();
        setAnnouncements(response.data);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError('Failed to load announcements.');
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, []);

  if (loading) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-bullhorn" title="Manage Announcements" />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-bullhorn" title="Manage Announcements" />
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle 
        icon="fa-bullhorn" 
        title="Manage Announcements" 
        action={
          <Link to="/admin/announcements/new" className="btn btn-primary">
            <i className="fas fa-plus me-2"></i>Create New Announcement
          </Link>
        }
      />
      {announcements.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          No announcements found.
        </div>
      ) : (
        <div className="card">
          <div className="card-body p-0">
            <ul className="list-group list-group-flush">
              {announcements.map(ann => (
                <li key={ann.id} className="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{ann.title}</strong>
                    <p className="mb-1 text-muted">{ann.description}</p>
                    <small className="text-muted">
                      <i className="fas fa-calendar-alt me-1"></i>
                      {new Date(ann.start_date).toLocaleDateString()}
                      {ann.expiry_date ? ` - ${new Date(ann.expiry_date).toLocaleDateString()}` : ''}
                    </small>
                  </div>
                  <div>
                    <Link to={`/admin/announcements/${ann.id}/edit`} className="btn btn-sm btn-outline-secondary me-2">
                      <i className="fas fa-edit me-1"></i>Edit
                    </Link>
                    <button onClick={() => handleDelete(ann.id)} className="btn btn-sm btn-outline-danger">
                      <i className="fas fa-trash me-1"></i>Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAnnouncements; 